var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapaneseCandlesticks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77148 2.93701C2.77148 2.79894 2.65956 2.68701 2.52148 2.68701C2.38341 2.68701 2.27148 2.79894 2.27148 2.93701V4.82849H1.72148C1.61103 4.82849 1.52148 4.91803 1.52148 5.02849V10.6285C1.52148 10.7389 1.61103 10.8285 1.72148 10.8285H2.27148V12.72C2.27148 12.858 2.38341 12.97 2.52148 12.97C2.65956 12.97 2.77148 12.858 2.77148 12.72V10.8285H3.32148C3.43194 10.8285 3.52148 10.7389 3.52148 10.6285V5.02849C3.52148 4.91803 3.43194 4.82849 3.32148 4.82849H2.77148V2.93701Z",
    fill: "#fbfbfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 3.1084C7.25 2.97033 7.13807 2.8584 7 2.8584C6.86193 2.8584 6.75 2.97033 6.75 3.1084V4.99988H6.2C6.08954 4.99988 6 5.08942 6 5.19988V10.7999C6 10.9103 6.08954 10.9999 6.2 10.9999H6.75V12.8914C6.75 13.0294 6.86193 13.1414 7 13.1414C7.13807 13.1414 7.25 13.0294 7.25 12.8914V10.9999H7.8C7.91046 10.9999 8 10.9103 8 10.7999V5.19988C8 5.08942 7.91046 4.99988 7.8 4.99988H7.25V3.1084Z",
    fill: "#fbfbfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6172 0.25C11.6172 0.111929 11.5053 0 11.3672 0C11.2291 0 11.1172 0.111929 11.1172 0.25V2.14148H10.5672C10.4567 2.14148 10.3672 2.23102 10.3672 2.34148V7.94148C10.3672 8.05194 10.4567 8.14148 10.5672 8.14148H11.1172V10.033C11.1172 10.171 11.2291 10.283 11.3672 10.283C11.5053 10.283 11.6172 10.171 11.6172 10.033V8.14148H12.1672C12.2776 8.14148 12.3672 8.05194 12.3672 7.94148V2.34148C12.3672 2.23102 12.2776 2.14148 12.1672 2.14148H11.6172V0.25Z",
    fill: "#fbfbfb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseCandlesticks);
export default __webpack_public_path__ + "static/media/JapaneseCandlesticks.3e713a793bc323a962fb9c2b9ae5401d.svg";
export { ForwardRef as ReactComponent };